import { Injectable } from '@angular/core';
import { environment } from '@environment';
import Keycloak, { KeycloakTokenParsed } from 'keycloak-js';
import { catchError, interval, of, switchMap } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class KeycloakService {
  //#region Properties

  private keycloakConfig: Keycloak;

  public get keycloak(): Keycloak {
    if (!this.keycloakConfig) {
      this.keycloakConfig = new Keycloak({
        clientId: environment.keycloak.clientId,
        realm: environment.keycloak.realm,
        url: environment.keycloak.url,
      });
    }
    return this.keycloakConfig;
  }

  //#endregion

  //#region Methods

  public async init(): Promise<void> {
    const authenticated = await this.keycloak.init({
      onLoad: 'login-required',
      redirectUri: window.location.origin,
      checkLoginIframe: false,
    });
    if (authenticated) {
      this.startTokenRefreshLoop();
    }
  }

  public login(): Promise<void> {
    return this.keycloak.login();
  }

  public logout(): Promise<void> {
    return this.keycloak.logout({ redirectUri: environment.keycloak.logoutUrl });
  }

  public getUsername(): string {
    const keycloakInfo = this.keycloak.idTokenParsed as
      | KeycloakTokenParsed
      | { given_name: string; family_name: string };

    return `${keycloakInfo.given_name} ${keycloakInfo.family_name}`;
  }

  public getUserOib(): string | null {
    const tokenParsed = this.keycloak.idTokenParsed as
      | KeycloakTokenParsed
      | { oib: string | null | undefined };

    return tokenParsed.oib;
  }

  private startTokenRefreshLoop(): void {
    const refreshInterval = 60_000;
    const minValiditySeconds = 70;
    interval(refreshInterval)
      .pipe(
        switchMap(() => this.keycloak.updateToken(minValiditySeconds)),
        catchError(() => {
          this.keycloak.logout();
          return of(null);
        }),
      )
      .subscribe();
  }

  //#endregion
}
